<template>
  <base-section
  id="registration"
  >
    <v-container>
    <base-section-heading
    title="Registration"
    color="secondary"
    align="left"
    :toColor="true"
    >
    The registration fees for LATS2025 are listed in the tables below. The deadline for the advance registration is the <strong>21st of February 2025</strong>.
    <br><br><strong>The registration website will be announced soon.</strong>
    </base-section-heading>
    <base-section-heading
    title="Advance Registration Fees (Until February 21)"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-data-table
        :headers="headers"
        :items="features"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
      </v-data-table>
    </base-section-heading>
    <base-section-heading
    title="Late/On-Site Registration Fees"
    color="secondary"
    align="left"
    :toColor="true"
    >
      <v-data-table
        :headers="headersLate"
        :items="featuresLate"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
      </v-data-table>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Registration',

    data: () => ({
      headers: [
        {
          text: 'Category',
          value: 'category',
          sortable: false,
          align: 'left',
        },
        {
          text: 'USD',
          value: 'usd',
          sortable: false,
          align: 'right',
        },
        {
          text: 'COP (Colombian Pesos)',
          value: 'cop',
          sortable: false,
          align: 'right',
        },
      ],
      headersLate: [
        {
          text: 'Category',
          value: 'category',
          sortable: false,
          align: 'left',
        },
        {
          text: 'USD',
          value: 'usd',
          sortable: false,
          align: 'right',
        },
        {
          text: 'COP (Colombian Pesos)',
          value: 'cop',
          sortable: false,
          align: 'right',
        },
      ],
      features: [
        {
        category: 'Professional IEEE Member',
        usd: '600',
        cop: '2.610.000',
        },
        {
        category: 'Professional NON-Member',
        usd: '700',
        cop: '3.045.000',
        },
        {
        category: 'Invited speaker, IEEE Fellow Member',
        usd: '500',
        cop: '2.175.000',
        },
        {
        category: 'Student IEEE Member',
        usd: '330',
        cop: '1.435.500',
        },
        {
        category: 'Student NON-Member',
        usd: '400',
        cop: '1.740.000',
        },
      ],
      featuresLate: [
        {
        category: 'Professional IEEE Member',
        usd: '700',
        cop: '3.045.000',
        },
        {
        category: 'Professional NON-Member',
        usd: '800',
        cop: '3.480.000',
        },
        {
        category: 'Invited speaker, IEEE Fellow Member',
        usd: '600',
        cop: '2.610.000',
        },
        {
        category: 'Student IEEE Member',
        usd: '430',
        cop: '1.870.000',
        },
        {
        category: 'Student NON-Member',
        usd: '500',
        cop: '2.175.000',
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

/* Remove border from last column */
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
  border-right: none;
}
</style>
